import { ApolloClient, InMemoryCache } from "@apollo/client";

const GetApolloClient = (access_token) => {

const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_URL,
  headers: {
    Authorization: `Bearer ${access_token}`,
  },
  fetchOptions: {
    mode: process.env.REACT_APP_GRAPHQL_CORS_ENABLED ? "cors" : "no-cors",
  },
  cache: new InMemoryCache(),
});
return client
}

export default GetApolloClient;
